import React,{useState,useEffect} from 'react';
import {connect} from 'react-redux';
import {portalLogin, clearErrors,logout,retryFailed} from '../store/authActions'
import M from 'materialize-css/dist/js/materialize.min.js';
import './toast.css';
import Navbar from './Navbar';
import RobotCheck from './RobotCheck';
import MailVerify from './MailVerify';
import {Base64} from 'js-base64';
import {useLocation} from 'react-router-dom';

const Login = ({isAuthenticated,error,portalLogin,clearErrors,history,robot,validMail,logout,userid,retryFailed}) => {
  const [user, setUser] = useState({password:'',token:''})
  const {password,token} = user;
  const [count, setCount] = useState(1);

   const location = useLocation();

  useEffect(()=>{
    if(isAuthenticated) {
      if(location.pathname==='/portaluserlogin'||location.pathname==='/portaluserlogin/') history.push('/portaluserpage');
      if(location.pathname==='/teachadminlogin'||location.pathname==='/teachadminlogin/') history.push('/teachadminhome');
    }

    if(error!==null) {
      if(error!==undefined) {
        M.toast({html: `${error}, attempt: ${count} / 3`, classes: 'red darken-2', displayLength: 5000});
        setCount(count+1);
        if(count>=3){
          retryFailed();
          setCount(1);
          M.toast({html: `please try again or contact support`, classes: 'orange darken-1', displayLength: 5000});
        }
      }
      if(error==='verification code expired') logout();
      
      clearErrors();
      setUser({password:'',token:''});
    }

  //eslint-disable-next-line
  },[isAuthenticated, error, history]);

  const onChange = (e) => setUser({...user, [e.target.name]: e.target.value})
  const onSubmit = (e) => {
    e.preventDefault();
    portalLogin({userid:userid.id,password:Base64.encode(password),token});
  }

  return (
    <>
      <Navbar title={'Local Account Login'}/>

      <div style={{'margin':'50px 0px 50px 0px'}}></div>
      <RobotCheck />

      <div style={{'margin':'50px 0px 50px 0px'}}></div>
      { !robot && <MailVerify /> }

      <div style={{'margin':'50px 0px 50px 0px'}}></div>
      <div className='container form-container'>
        { validMail &&
          <form onSubmit={onSubmit}>
            <div className='form-group'>
              <label htmlFor='token'>Email verification code</label>
              <input type='text' name='token' value={token} onChange={onChange} required />
            </div> 
            <div className='form-group'>
              <label htmlFor='password'>Password</label>
              <input type='password' name='password' value={password} onChange={onChange} required />
            </div> 
            <input type='submit' value='Login' className='btn btn-primary btn-block' />
          </form>
        }
      </div>
    </>
  );
};

const mapStoreToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
  error: state.auth.error,
  robot: state.auth.robot,
  validMail: state.auth.validMail,
  userid: state.auth.userid
});

export default connect(mapStoreToProps,{portalLogin,clearErrors,logout,retryFailed})(Login)
